export default function NBAGamePanel({ game }) {
  const away = game.awayTeam || {};
  const home = game.homeTeam || {};
  const teamStats = game.teamStats || [];
  const awayStats = (teamStats.find(t => t.teamId === away.id) || {}).stats || {};
  const homeStats = (teamStats.find(t => t.teamId === home.id) || {}).stats || {};

  const statRows = [
    { label: "FG%", away: awayStats["fieldGoalPct"], home: homeStats["fieldGoalPct"] },
    { label: "3PT%", away: awayStats["threePointFieldGoalPct"], home: homeStats["threePointFieldGoalPct"] },
    { label: "FT%", away: awayStats["freeThrowPct"], home: homeStats["freeThrowPct"] },
    { label: "Rebounds", away: awayStats["totalRebounds"], home: homeStats["totalRebounds"] },
    { label: "Assists", away: awayStats["assists"], home: homeStats["assists"] },
    { label: "Turnovers", away: awayStats["turnovers"], home: homeStats["turnovers"] },
    { label: "Steals", away: awayStats["steals"], home: homeStats["steals"] },
    { label: "Blocks", away: awayStats["blocks"], home: homeStats["blocks"] },
  ].filter(r => r.away || r.home);

  return (
    <div className="space-y-4" data-testid="nba-panel">
      {/* Quarter-by-quarter */}
      <div className="bg-[#141414] border border-white/10 rounded-xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-white/10 text-white/40 uppercase tracking-wider">
                <th className="text-left px-4 py-2.5 w-44">Team</th>
                {(home.linescores || away.linescores || []).map((_, i) => (
                  <th key={i} className="text-center px-3 py-2.5 w-10">Q{i + 1 > 4 ? "OT" : i + 1}</th>
                ))}
                <th className="text-center px-3 py-2.5 w-12 bg-white/5 font-bold">T</th>
              </tr>
            </thead>
            <tbody>
              {[away, home].map((team) => (
                <tr key={team.id} className="border-b border-white/5 hover:bg-white/5">
                  <td className="px-4 py-2.5">
                    <div className="flex items-center gap-2">
                      {team.logo && <img src={team.logo} alt="" className="w-5 h-5 object-contain" />}
                      <span className="font-semibold text-white">{team.displayName || team.name}</span>
                    </div>
                  </td>
                  {(team.linescores || []).map((s, i) => (
                    <td key={i} className="text-center px-3 py-2.5 score-font text-white/60">{s}</td>
                  ))}
                  <td className="text-center px-3 py-2.5 score-font font-bold text-white bg-white/5">{team.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Team stats comparison */}
      {statRows.length > 0 && (
        <div className="bg-[#141414] border border-white/10 rounded-xl p-4" data-testid="nba-stats">
          <h3 className="font-['Bebas_Neue'] text-lg uppercase tracking-wider text-white mb-3">Team Stats</h3>
          <div className="space-y-3">
            {statRows.map((row) => {
              const aVal = parseFloat(row.away) || 0;
              const hVal = parseFloat(row.home) || 0;
              const max = Math.max(aVal, hVal, 1);
              const isInverse = row.label === "Turnovers";
              return (
                <div key={row.label}>
                  <div className="flex items-center justify-between text-xs mb-1">
                    <span className={`score-font ${!isInverse && aVal >= hVal ? "text-white font-bold" : "text-white/50"}`}>{row.away || "0"}</span>
                    <span className="text-white/40 uppercase tracking-wider text-[10px]">{row.label}</span>
                    <span className={`score-font ${!isInverse && hVal >= aVal ? "text-white font-bold" : "text-white/50"}`}>{row.home || "0"}</span>
                  </div>
                  <div className="flex gap-1 h-1.5">
                    <div className="flex-1 flex justify-end">
                      <div className="h-full rounded-l" style={{ width: `${(aVal / max) * 100}%`, backgroundColor: away.color ? `#${away.color}` : "#007AFF" }} />
                    </div>
                    <div className="flex-1">
                      <div className="h-full rounded-r" style={{ width: `${(hVal / max) * 100}%`, backgroundColor: home.color ? `#${home.color}` : "#FF3B30" }} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="flex justify-between mt-3 text-[10px] text-white/30">
            <span className="flex items-center gap-1"><span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: away.color ? `#${away.color}` : "#007AFF" }} />{away.abbreviation}</span>
            <span className="flex items-center gap-1">{home.abbreviation}<span className="w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: home.color ? `#${home.color}` : "#FF3B30" }} /></span>
          </div>
        </div>
      )}
    </div>
  );
}
